import React, { useEffect } from "react";
import Parental_Banner from "./parental-banner/Parental_Banner";
import What_Is_Counselling from "./what-is-counselling/What_Is_Counselling";
import Counselling_Process from "./counselling-steps/Counselling_Process";
import Opt_For_Parental_Counselling from "./opt-for-parental-counselling/Opt_For_Parental_Counselling";
import Parental_Assessment from "./parental-assessment/Parental_Assessment";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllhowcounselling,
  GetAllpbanner,
  GetAllwhatcounselling,
  GetAllwhopt,
} from "../../redux/parentalcounselling";

const Parental_Counselling = () => {
  const dispatch = useDispatch();
  const pbanner = useSelector((state) => state?.parentalcounselling?.pbanner);
  const what_counselling = useSelector(
    (state) => state?.parentalcounselling?.what_counselling,
  );
  const how_counselling = useSelector(
    (state) => state?.parentalcounselling?.how_counselling,
  );
  const who_should_opt = useSelector(
    (state) => state?.parentalcounselling?.who_should_opt,
  );

  useEffect(() => {
    dispatch(GetAllpbanner());
    dispatch(GetAllwhatcounselling());
    dispatch(GetAllhowcounselling());
    dispatch(GetAllwhopt());
  }, [dispatch]);

  return (
    <>
      <Parental_Banner pbanner={pbanner} />
      <What_Is_Counselling what_counselling={what_counselling} />
      <Counselling_Process how_counselling={how_counselling} />
      <Opt_For_Parental_Counselling who_should_opt={who_should_opt} />
      <Parental_Assessment />
    </>
  );
};

export default Parental_Counselling;
